var map = {
	"./chat": 9543,
	"./chat.js": 9543,
	"./chat_document_manager": 4159,
	"./chat_document_manager.js": 4159,
	"./chat_handler": 688,
	"./chat_handler.js": 688,
	"./chat_render": 4574,
	"./chat_render.js": 4574,
	"./helpers": 3104,
	"./helpers.js": 3104,
	"./scroll_chat_down": 8148,
	"./scroll_chat_down.js": 8148,
	"./typing_receiving_manager": 2011,
	"./typing_receiving_manager.js": 2011,
	"./typing_sending_manager": 8867,
	"./typing_sending_manager.js": 8867,
	"javascript/legacy/chat/chat": 9543,
	"javascript/legacy/chat/chat.js": 9543,
	"javascript/legacy/chat/chat_document_manager": 4159,
	"javascript/legacy/chat/chat_document_manager.js": 4159,
	"javascript/legacy/chat/chat_handler": 688,
	"javascript/legacy/chat/chat_handler.js": 688,
	"javascript/legacy/chat/chat_render": 4574,
	"javascript/legacy/chat/chat_render.js": 4574,
	"javascript/legacy/chat/helpers": 3104,
	"javascript/legacy/chat/helpers.js": 3104,
	"javascript/legacy/chat/scroll_chat_down": 8148,
	"javascript/legacy/chat/scroll_chat_down.js": 8148,
	"javascript/legacy/chat/typing_receiving_manager": 2011,
	"javascript/legacy/chat/typing_receiving_manager.js": 2011,
	"javascript/legacy/chat/typing_sending_manager": 8867,
	"javascript/legacy/chat/typing_sending_manager.js": 8867
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6574;